// extracted by css-extract-rspack-plugin
export default {"SectionHeader":"SectionHeader-module__SectionHeader__JIjGm","SectionHeader__body":"SectionHeader-module__SectionHeader__body__EEddU"};